import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=02df480a&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=02df480a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df480a",
  null
  
)

export default component.exports